import { z } from 'zod';

import { AppCertificationTypeEnum, AppProductTypeEnum } from 'src/graphql/schema';

export const filterSchema = z.object({
  setupStatus: z.array(z.enum(['needs_finishing', 'no_protection_yet'])).optional(),
  tasks: z.array(z.enum(['with_tasks', 'all_clear'])).optional(),
  productIncluded: z.array(z.nativeEnum(AppProductTypeEnum)).optional(),
  assuranceReached: z.array(z.nativeEnum(AppCertificationTypeEnum)).optional(),
});

export type FilterFormValues = z.infer<typeof filterSchema>;
